const FETCH_USER_INFO_PENDING = "user/FETCH_USER_INFO";
const FETCH_USER_INFO_SUCCESS = "user/FETCH_USER_INFO_SUCCESS";
const FETCH_USER_INFO_FAIL = "user/FETCH_USER_INFO_FAIL";

const initialState = {
  pending: true,
  loaded: false,
  user: {
    coins: 0,
    total_coins: 0
  },
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_USER_INFO_PENDING:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case FETCH_USER_INFO_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        user: { ...action.results },
        error: null
      });
    case FETCH_USER_INFO_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        error: action.error
      });
    default:
      return state;
  }
}

export function fetchUserInfoPending() {
  return {
    type: FETCH_USER_INFO_PENDING
  };
}

export function fetchUserInfoSuccess(results) {
  return {
    type: FETCH_USER_INFO_SUCCESS,
    results
  };
}

export function fetchUserInfoFail(error) {
  return {
    type: FETCH_USER_INFO_FAIL,
    error
  };
}

export const getUser = state => state.user;
export const getError = state => state.error;
export const getPending = state => state.pending;
export const getLoaded = state => state.loaded;
